import {Delegacia} from "../delegacia";

export class DelegaciaCmd {
    id?: number = -1;
    nome: string = "";
    email?: string = "";
    telefone?: string = "";
    areaId: string = "-1";
    ativa: boolean = false;

    static paraCmd(delegacia: Delegacia): DelegaciaCmd {
        let cmd = new DelegaciaCmd();
        cmd.id = delegacia.id;
        cmd.nome = delegacia.nome;
        cmd.email = delegacia.email;
        cmd.telefone = delegacia.telefone;
        cmd.areaId = delegacia.area.id?.toString() ?? "-1";
        cmd.ativa = delegacia.ativa;
        return cmd;
    }

}
